



















































































































import Vue from "vue";
import { alert, confirm } from "@/services/dialog";
import { Shop, MobileOrderConfig } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { v4 as Uuidv4 } from "uuid";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "MobileOrderSetting",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker },
  data() {
    return {
      basepath: "shop/" + this.shopId + "/"
    };
  },
  computed: {
    collection(): Collection<MobileOrderConfig> {
      return new Collection(
        db.collection("moConfig") as firestore.CollectionReference<
          MobileOrderConfig
        >
      );
    },
    document(): Document<MobileOrderConfig> {
      const id = this.$route.params.id;
      return this.collection.doc(this.shopId, { noListen: true });
    }
  },
  methods: {
    async register() {
      if (this.document.canSave) {
        const result = await this.document.save().catch(e => {
          console.log(e);
          alert({
            title: "エラー",
            text: "モバイルオーダー設定の保存に失敗しました。"
          });
        });
        if (result) {
          this.$router.push("/");
        }
      } else {
        alert({
          title: "エラー",
          text: "モバイルオーダー設定が変更されていません。"
        });
      }
    },
    async uploadFile(
      event: Event,
      targetProp: string,
      width: number,
      height: number
    ) {
      if (event.target instanceof HTMLInputElement) {
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択、もしくは撮影してください。"
          });
          event.target.value = "";
        } else {
          // const _this = this;
          event.target.files.forEach((item: File) => {
            loadImage(
              item,
              img => {
                //upload to firebase storage
                const _path = this.basepath + Uuidv4() + ".jpg";
                const ref = firebaseProject
                  .storage()
                  .ref()
                  .child(_path);
                const type = "image/jpg";
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const dataUri = (img as any).toDataURL(type, 0.8);
                const bin = atob(dataUri.split(",")[1]);
                const buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                  buffer[i] = bin.charCodeAt(i);
                }
                const blob = new Blob([buffer.buffer], { type: type });
                ref
                  .put(blob, { contentType: type })
                  .then(() => {
                    const url = _path;
                    switch (targetProp) {
                      case "drivethruAreaImage":
                        this.document.effective.drivethruAreaImage = _path;
                        break;
                      case "drivethruNoticeImage":
                        this.document.effective.drivethruNoticeImage = _path;
                        break;
                      case "parkAndPickupAreaImage":
                        this.document.effective.parkAndPickupAreaImage = _path;
                        break;
                      case "parkAndPickupNoticeImage":
                        this.document.effective.parkAndPickupNoticeImage = _path;
                        break;
                    }
                  })
                  .catch(error => {
                    console.log(error);
                  });
              },
              {
                maxWidth: width,
                maxHeight: height,
                canvas: true
              }
            );
          });
          event.target.value = "";
        }
      }
    }
  }
});
